const delayTime = 100;
const interval_time = 4000;
export { delayTime, interval_time };



// WEBPACK FOOTER //
// ./src/utils/constant.js